import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from '../components';
import DragAndDrop from '../components/Form/DragAndDrop';
import { PageTitle } from '../components/Text';
import TwoRows from '../components/Structure/TwoRows';
import ActionButton from '../components/Button/Action';
import { Button } from '../components/Button';
import useFileUploadAction from '../hooks/useFileUploadAction';
import { Row } from '../components/Structure';
import './FileUploadScreen.scss';

const FileUploadScreen = () => {
  const [formData, setFormData] = useState(new FormData());
  const [disableButton, setDisableButton] = useState(true);
  const history = useHistory();
  const uploadFiles = useFileUploadAction();

  const onFileChange = (files, isValid) => {
    const newFormData = new FormData();
    setDisableButton(!isValid);
    Array.from(files).forEach((file, index) => {
      newFormData.append(`evidence_files[${index}]`, file, file.name);
    });
    setFormData(newFormData);
  };

  const handleSubmit = async () => {
    await uploadFiles(formData);
    setDisableButton(true);
  };

  return (
    <Page id="main">
      <div className="primary-content">
        <PageTitle>Attach evidence files</PageTitle>
        <p>
          Please attach all required evidence, so that this process can be
          completed
        </p>
      </div>
      <Row>
        <DragAndDrop onFileChange={onFileChange} />
      </Row>
      <TwoRows className="nav-buttons">
        <Button classButton="back" onPress={history.goBack}>
          Back
        </Button>
        <ActionButton
          processing={disableButton}
          classButton="send-form"
          type="submit"
          onPress={handleSubmit}
        >
          Next
        </ActionButton>
      </TwoRows>
    </Page>
  );
};

export default FileUploadScreen;
